import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { LoadSpinner } from "./LoadSpinner";
import { Table, Row, Col, Form, InputGroup, Navbar } from "react-bootstrap";

export class LedgerBook extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      dateRange: "This Month",
      fromDate: "",
      toDate: "",
      credits: [],
      debits: [],
      loadSpinnerOpen: false,
    };
  }
  printRef = React.createRef();

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  fmt = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${dd}`;
  };

  calcRange = (key) => {
    const t = new Date();
    const z = new Date(t.getFullYear(), t.getMonth(), t.getDate());
    if (key === "Today") return { from: this.fmt(z), to: this.fmt(z) };
    if (key === "Yesterday") {
      const y = new Date(z.getFullYear(), z.getMonth(), z.getDate() - 1);
      return { from: this.fmt(y), to: this.fmt(y) };
    }
    if (key === "This Week") {
      const d = z.getDay();
      const diff = d === 0 ? -6 : 1 - d;
      const mon = new Date(z.getFullYear(), z.getMonth(), z.getDate() + diff);
      const sun = new Date(
        mon.getFullYear(),
        mon.getMonth(),
        mon.getDate() + 6
      );
      return { from: this.fmt(mon), to: this.fmt(sun) };
    }
    if (key === "Last Week") {
      const d = z.getDay();
      const diff = d === 0 ? -6 : 1 - d;
      const thisMon = new Date(
        z.getFullYear(),
        z.getMonth(),
        z.getDate() + diff
      );
      const lastMon = new Date(
        thisMon.getFullYear(),
        thisMon.getMonth(),
        thisMon.getDate() - 7
      );
      const lastSun = new Date(
        lastMon.getFullYear(),
        lastMon.getMonth(),
        lastMon.getDate() + 6
      );
      return { from: this.fmt(lastMon), to: this.fmt(lastSun) };
    }
    return null;
  };

  printReport = () => {
    const printContents = this.printRef.current.innerHTML;

    const storeName = this.context.storeSettings?.storeName || "";
    const storeAddress = this.context.storeSettings?.storeAddress || "";
    const storeEmail = this.context.storeSettings?.storeEmailId || "";
    const storePhone = this.context.storeSettings?.storePhoneNo || "";
    const reportTitle = "Ledger Book Report";

    // const dateSection = this.context.GetDateResult(
    //   this.state.dateRange,
    //   this.state.fromDate,
    //   this.state.toDate
    // );
    const dateSection = this.context.GetDateResult(
      this.state.dateRange,
      new Date(this.state.fromDate),
      new Date(this.state.toDate)
    );

    const win = window.open("", "", "height=800,width=1000");

    win.document.write(`
    <html>
      <head>
        <title>${reportTitle}</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
          .header {
            text-align: center;
            margin-bottom: 20px;
          }
          .header h2 {
            margin: 0;
          }
          .meta {
            font-size: 12px;
            margin-top: 4px;
          }
          hr {
            margin: 12px 0;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12px;
          }
          th, td {
            border: 1px solid #000;
            padding: 6px;
          }
          th {
            background: #f2f2f2;
          }
          .text-end {
            text-align: right;
          }
        </style>
      </head>
      <body>

        <div class="header">
          <h2>${storeName}</h2>
          <div class="meta">${storeAddress}</div>
          <div class="meta">
            ${storeEmail} ${storePhone ? " | " + storePhone : ""}
          </div>
          <hr />
          <h3>${reportTitle}</h3>
          <div class="meta"><b>${dateSection}</b></div>
        </div>

        ${printContents}

      </body>
    </html>
  `);

    win.document.close();
    win.focus();
    win.print();
    win.close();
  };

  GetLedgerBook = () => {
    this.ShowLoadSpinner();

    // const rangeKey = this.state.dateRange;
    // const calc = this.calcRange(rangeKey);
    // const dateParam = calc ? `${calc.from}_${calc.to}` : rangeKey;

    const rangeKey = this.state.dateRange;
    let dateParam = rangeKey;

    if (rangeKey === "Custom" && this.state.fromDate && this.state.toDate) {
      dateParam = `${this.state.fromDate}_${this.state.toDate}`;
    }

    const url =
      process.env.REACT_APP_API +
      "Account/GetLedgerBook/" +
      this.context.storeId +
      "/" +
      encodeURIComponent(dateParam);

    fetch(url)
      .then((r) => r.json())
      .then((data) => {
        this.setState(
          {
            credits: data.credits || [],
            debits: data.debits || [],
          },
          this.HideLoadSpinner
        );
      })
      .catch((e) => {
        console.error(e);
        this.HideLoadSpinner();
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.dateRange === "Custom" &&
      this.state.fromDate &&
      this.state.toDate &&
      (prevState.fromDate !== this.state.fromDate ||
        prevState.toDate !== this.state.toDate)
    ) {
      this.GetLedgerBook();
    }
  }

  formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return "";

    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.GetLedgerBook();
  }

  sum = (list) =>
    list.reduce((a, b) => a + Number(b.amount || 0), 0).toFixed(2);

  render() {
    const { credits, debits } = this.state;

    return (
      <>
        {this.state.loadSpinnerOpen ? <LoadSpinner open="true" /> : ""}

        <Navbar className="shadow position-sticky fixed-top py-3 text-black">
          <h3>
            <b>Ledger Book</b>
          </h3>
        </Navbar>

        <div className="p-3 bg-light mt-5">
          {/* Date Range Selector */}
          <InputGroup className="mb-3">
            <InputGroup.Text>Date Range</InputGroup.Text>
            <Form.Select
              value={this.state.dateRange}
              onChange={(e) =>
                this.setState({ dateRange: e.target.value }, this.GetLedgerBook)
              }
            >
              <option value="Today">Today</option>
              <option value="Yesterday">Yesterday</option>
              <option value="This Week">This Week</option>
              <option value="Last Week">Last Week</option>
              <option value="This Month">This Month</option>
              <option value="Last Month">Last Month</option>
              <option value="Custom">Custom</option>
            </Form.Select>
          </InputGroup>

          {/* Custom Date Range */}
          {this.state.dateRange === "Custom" && (
            <Row className="mb-3">
              <Col md={4}>
                <Form.Control
                  type="date"
                  value={this.state.fromDate}
                  onChange={(e) => this.setState({ fromDate: e.target.value })}
                />
              </Col>
              <Col md={4}>
                <Form.Control
                  type="date"
                  value={this.state.toDate}
                  onChange={(e) => this.setState({ toDate: e.target.value })}
                />
              </Col>
              <Col md={4}>
                <button
                  className="btn btn-primary w-100"
                  onClick={this.GetLedgerBook}
                >
                  Apply
                </button>
              </Col>
            </Row>
          )}

          <div className="d-flex justify-content-end mb-3">
            <button
              className="btn btn-outline-secondary"
              disabled={
                this.state.dateRange === "Custom" &&
                this.state.fromDate &&
                this.state.toDate &&
                this.state.credits.length === 0 &&
                this.state.debits.length === 0
              }
              onClick={this.printReport}
            >
              🖨️ Print Report
            </button>
          </div>

          <div ref={this.printRef}>
            {/* Two Column Layout */}
            <Row>
              {/* Credits */}
              <Col className="border p-3">
                <h3 className="text-center">CREDITS</h3>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Category</th>
                      <th>Details</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {credits.map((c, i) => (
                      <tr key={i}>
                        <td>{this.formatDate(c.date)}</td>
                        <td>{c.type}</td>
                        <td>{c.details}</td>
                        <td className="text-end">
                          {Number(c.amount).toFixed(0)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <h4 className="text-end">
                  <b>Total Credits: {Number(this.sum(credits)).toFixed(0)}</b>
                </h4>
              </Col>

              {/* Debits */}
              <Col className="border p-3">
                <h3 className="text-center">DEBITS</h3>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Category</th>
                      <th>Details</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {debits.map((d, i) => (
                      <tr key={i}>
                        <td>{this.formatDate(d.date)}</td>
                        <td>{d.type}</td>
                        <td>{d.details}</td>
                        <td className="text-end">
                          {Number(d.amount).toFixed(0)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <h4 className="text-end">
                  <b>Total Debits: {Number(this.sum(debits)).toFixed(0)}</b>
                </h4>
              </Col>
            </Row>
            {/* Summary */}
            <Row className="mt-4 p-3 border">
              <Col className="text-center">
                <h2>
                  Balance = Credits − Debits ={" "}
                  {(
                    Number(this.sum(credits)) - Number(this.sum(debits))
                  ).toFixed(0)}
                </h2>
              </Col>
            </Row>
          </div>
        </div>
      </>
    );
  }
}
